@if (isBrowser) {
  @if (score() !== null) {
    <div
      echarts
      [options]="options()"
      class="gauge"
      [style.height.px]="height()"
      role="img"
      [attr.aria-label]="'Индекс на прегряване: ' + score()"
    ></div>
  } @else {
    <div class="gauge gauge-empty" [style.height.px]="height()">
      Няма достатъчно история за индекса
    </div>
  }
} @else {
  <div class="gauge" [style.height.px]="height()"></div>
}
